import { Component, Input, OnInit } from '@angular/core';
import { Svgs } from '../base/base.component';
import { ContractStateContextComponent } from '../state-context/state-context.component';
import { IContractState } from '../state.interface';
import * as moment from 'moment';

import { DataSourceService } from './../../../services/data-source.service';
import { Uploadable } from '@akiba/models_bimbo';
import { UploadService } from '../../../services/upload.service';

// ----------------------------------------------------------------------------------------
@Component({
  templateUrl: './uploading.state.html'
})
export class UploadingStateComponent implements IContractState, OnInit {
  context!: ContractStateContextComponent;
  constructor(private dataService: DataSourceService, private uploadService: UploadService) { }

  //@Input() ContractModel contract;
  @Input() employeeNumber: string;
  @Input() ssID: string;
  @Input() file: File;
  // ----------------------------------------------------------------------------------------
  ngOnInit(): void {
    this.onUploadSignedContract();
  }
  // ----------------------------------------------------------------------------------------
  private async onUploadSignedContract() {
    console.log('file', this.file);
    const arrayName = this.file.name.split('.');
    const typeName = arrayName.pop();
    let compactedFile: File;

    if (typeName !== 'pdf') {
      let newFile = await this.compressImage(this.file, 50);
      compactedFile = new File([newFile], this.file.name);

    } else {
      compactedFile = this.file;
    }

    let file = await this.readFile(compactedFile, typeName);

    try {

      this.uploadService.pushUpload(file);
      this.uploadService.downloadURLSubject.subscribe(downloadURL => {
        this.updateContractToSigned(downloadURL);
      });

    } catch {
      this.context.setGeneratedState();
    }

  }
  // ----------------------------------------------------------------------------------------
  private updateContractToSigned(url: String) {
    //Actualizar el documento active contract 
    const dataSave = {
      contractSignedURL: url,
      status: 'signed'
    };

    this.dataService.markSavingContract(this.ssID, dataSave).catch(error => {
      console.log('ContractToSignedError', error.message);
    });

  }


  // ----------------------------------------------------------------------------------------

  readFile(archive, typeName): Promise<Uploadable> {
    const file: File = archive;
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      let fileUploaded = new Uploadable();
      const dateName = moment(new Date()).format('-MMM-YY');
      const fileName = this.employeeNumber + dateName + '.';


      reader.onload = () => {
        fileUploaded.file = file;
        fileUploaded.name = fileName + typeName;
        fileUploaded.bucket = 'stocks/contracts/signed/' + fileName + typeName;
        resolve(fileUploaded);
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    })



  }
  //---------------------------------------------------------------------------------------------------------
  compressImage(imageFile, percentage): Promise<any> {
    return new Promise((resolve, reject) => {
      const $canvas = document.createElement("canvas");
      const image = new Image();
      image.onload = () => {

        const MAX_WIDTH = 1241;
        const MAX_HEIGHT = 1754;
        let width = image.width;
        let height = image.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        $canvas.width = width;
        $canvas.height = height;
        $canvas.getContext("2d").drawImage(image, 0, 0, width, height);
        $canvas.toBlob(
          (blob) => {
            if (blob === null) {
              return reject(blob);
            } else {
              resolve(blob);
            }
          },
          "image/jpeg",
          percentage / 100
        );
      };
      image.src = URL.createObjectURL(imageFile);
    });
  };

  // ----------------------------------------------------------------------------------------
  nextState(): void {
    this.context.setInitialState();
  }
  svg: Svgs = Svgs.ForUpload
}


